import { createStore, applyMiddleware, compose } from "redux";
import reducer from "./reducers";
import thunkMiddleware from "redux-thunk";

const composeEnhancers = (process.env.NODE_ENV === "development" ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : null) || compose;
const store = createStore(reducer, composeEnhancers(applyMiddleware(thunkMiddleware)));

export default store;
